var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 6,
    fill: "#88D4FF",
    stroke: "#88D4FF",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_151_127420",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_151_127420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8001 19.9998L11.4001 17.9998C11.1334 17.8887 10.8834 17.7721 10.6501 17.6498C10.4167 17.5276 10.1779 17.3776 9.93341 17.1998L8.00008 17.7998L6.66675 15.5332L8.20008 14.1998C8.15564 13.9109 8.13341 13.6221 8.13341 13.3332C8.13341 13.0443 8.15564 12.7554 8.20008 12.4665L6.66675 11.1332L8.00008 8.8665L9.93341 9.4665C10.1779 9.28873 10.4167 9.13873 10.6501 9.0165C10.8834 8.89428 11.1334 8.77762 11.4001 8.6665L11.8001 6.6665H14.4667L14.8667 8.6665C15.1334 8.77762 15.3834 8.89428 15.6167 9.0165C15.8501 9.13873 16.089 9.28873 16.3334 9.4665L18.2667 8.8665L19.6001 11.1332L18.0667 12.4665C18.1112 12.7554 18.1334 13.0443 18.1334 13.3332C18.1334 13.6221 18.1112 13.9109 18.0667 14.1998L19.6001 15.5332L18.2667 17.7998L16.3334 17.1998C16.089 17.3776 15.8501 17.5276 15.6167 17.6498C15.3834 17.7721 15.1334 17.8887 14.8667 17.9998L14.4667 19.9998H11.8001ZM13.1334 15.9998C13.8667 15.9998 14.4945 15.7387 15.0167 15.2165C15.539 14.6943 15.8001 14.0665 15.8001 13.3332C15.8001 12.5998 15.539 11.9721 15.0167 11.4498C14.4945 10.9276 13.8667 10.6665 13.1334 10.6665C12.4001 10.6665 11.7723 10.9276 11.2501 11.4498C10.7279 11.9721 10.4667 12.5998 10.4667 13.3332C10.4667 14.0665 10.7279 14.6943 11.2501 15.2165C11.7723 15.7387 12.4001 15.9998 13.1334 15.9998ZM23.7334 34.6665L23.1334 31.8665C22.7556 31.7332 22.4056 31.5721 22.0834 31.3832C21.7612 31.1943 21.4445 30.9776 21.1334 30.7332L18.4667 31.5998L16.6001 28.3998L18.7334 26.5332C18.689 26.1332 18.6667 25.7332 18.6667 25.3332C18.6667 24.9332 18.689 24.5332 18.7334 24.1332L16.6001 22.2665L18.4667 19.0665L21.1334 19.9332C21.4445 19.6887 21.7612 19.4721 22.0834 19.2832C22.4056 19.0943 22.7556 18.9332 23.1334 18.7998L23.7334 15.9998H27.4667L28.0667 18.7998C28.4445 18.9332 28.7945 19.0943 29.1167 19.2832C29.439 19.4721 29.7556 19.6887 30.0667 19.9332L32.7334 19.0665L34.6001 22.2665L32.4667 24.1332C32.5112 24.5332 32.5334 24.9332 32.5334 25.3332C32.5334 25.7332 32.5112 26.1332 32.4667 26.5332L34.6001 28.3998L32.7334 31.5998L30.0667 30.7332C29.7556 30.9776 29.439 31.1943 29.1167 31.3832C28.7945 31.5721 28.4445 31.7332 28.0667 31.8665L27.4667 34.6665H23.7334ZM25.6001 29.3332C26.7112 29.3332 27.6556 28.9443 28.4334 28.1665C29.2112 27.3887 29.6001 26.4443 29.6001 25.3332C29.6001 24.2221 29.2112 23.2776 28.4334 22.4998C27.6556 21.7221 26.7112 21.3332 25.6001 21.3332C24.489 21.3332 23.5445 21.7221 22.7667 22.4998C21.989 23.2776 21.6001 24.2221 21.6001 25.3332C21.6001 26.4443 21.989 27.3887 22.7667 28.1665C23.5445 28.9443 24.489 29.3332 25.6001 29.3332Z",
    fill: "#002E40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSetup);
export default __webpack_public_path__ + "static/media/ActiveSetup.bc65a98507ceb01454cedba4088e9c62.svg";
export { ForwardRef as ReactComponent };